import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
import { mapGetters } from 'vuex';
export default {
  name: 'Empty',
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }))
};